import CryptoJS from 'crypto'
import { ApiService } from '.'

const SECRET = 'YiSvygG2EI2jHSyHKgKfpv'

class EcommerceService extends ApiService {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL)
  }

  generateHeaderHash = () => {
    if (window) {
      return window.btoa(
        JSON.stringify({
          alg: 'HS256',
          typ: 'JWT',
        }),
      )
    }
    return ''
  }

  generateIat = (): string => {
    const now = new Date()
    return `${now.getFullYear()}-${
      now.getMonth() + 1
    }-${now.getDate()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
  }

  generateSignature = (payload: string) => {
    const headerHash = this.generateHeaderHash()
    return CryptoJS.createHmac('sha256', SECRET).update(`${headerHash}.${payload}`).digest().toString('base64')
  }
}

export default EcommerceService
